<template>
  <fragment>
    <tr
      v-for="(docInfo, fIndex) in docs"
      :key="fIndex"
      v-bind:class="{
        'document-file-delete': fileData[fIndex] && fileData[fIndex].isDeleted,
        'accept-y': fileData[fIndex] && fileData[fIndex].acceptStatus === 1,
        'accept-n': fileData[fIndex] && fileData[fIndex].acceptStatus === 2
      }"
    >
      <td>
        <span v-if="fIndex === 0">{{ index }}.{{ docIndex + 1 }}</span>
        <span v-else-if="(docInfo.IS_MULTIPLY || docInfo.UF_IS_MULTY)">{{ index }}.{{ fIndex + 1 }}</span>

      </td>
      <td style="min-width: 32px;">
        <VDropdown
          v-if="docInfo.HELP_TYPE"
          tag="span"
          trigger="click"
          placement="bottom"
          popperClass="custom-popper"
          :distance="25"
          style="display: inline-block"
        >
          <a class="icon-help-blue" style="margin-top: 2px;"></a>
          <template #popper>
            <div class="custom-popper-content" v-html="docInfo.HELP_TYPE"></div>
          </template>
        </VDropdown>
      </td>
      <td>
        <a
          v-if="docInfo.SHABLON_LINK_TYPE"
          class="icon-shablon-blue"
          :href="docInfo.SHABLON_LINK_TYPE"
          target="_blank"
          style="display: inline-block;position: initial; margin-left: 10px; margin-top: 10px;"
        >&nbsp;</a
        > <a
        v-else-if="docInfo.SHABLON_LINK"
        class="icon-shablon-blue"
        :href="docInfo.SHABLON_LINK"
        target="_blank"
        style="display: inline-block;position: initial; margin-left: 10px; margin-top: 10px;"
      >&nbsp;</a
      >

        <a
          v-else-if="docInfo.IS_VIEW_FEE && project.UF_SETTING && project.UF_SETTING.LINK_FIE_HELP"
          class="icon-shablon-blue"
          :href="project.UF_SETTING && project.UF_SETTING.LINK_FIE_HELP"
          target="_blank"
          style="display: inline-block;position: initial; margin-left: 30px; margin-top: 12px;"
        >&nbsp;</a
        >
      </td>
      <!-- Ссылка название документа -->
      <!-- <td
        v-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID ===
              loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
                'UF_EXPERTISE_ID'
              ]
        "
      >
        <a
          style="display: inline-block;"
          :href="
            loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)['FILE']
          "
          @click="
            logFileClick(
              loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)['ID']
            )
          "
          class="doc-link"
          target="blank"
          ><span v-if="!docInfo.IS_MULTIPLY">{{ docInfo.NAME }} </span>
          <span v-else>{{ docInfo.NAME }}</span>
          <span v-if="docInfo.IS_REQ_FILE" class="req_doc">*</span></a
        >
      </td>-->
      <!-- Ссылка название документа -->
      <td
        v-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID === 0
        "
      >
        <a
          style="display: inline-block;"
          :href="loadedFile(docInfo.TYPE_ID, fIndex)['FILE']"
          @click="logFileClick(loadedFile(docInfo.TYPE_ID, fIndex)['ID'])"
          class="doc-link"
          target="blank"
        >
          <span v-if="!docInfo.IS_MULTIPLY">
            <span v-html="docInfo.NAME_TYPE_DOCUMENT && docInfo.NAME_TYPE_DOCUMENT !== '' ? docInfo.NAME_TYPE_DOCUMENT : docInfo.NAME"></span>
          </span>
          <span v-else>
            {{ loadedFile(docInfo.TYPE_ID, fIndex).UF_USER_FILE_NAME }}
          </span>
        </a>
        <span v-if="docInfo.IS_REQ_FILE" class="req_doc">*</span>

        <template
          v-if="
            docInfo.IS_GENERATE_PREZENT &&
              docInfo.GENERATE_PREZENT_LINK &&
              currentUser.TYPE_USER === 'manager'
          "
        >
          <a
            class="btn btn-info"
            target="_blank"
            :href="
              docInfo.GENERATE_PREZENT_LINK.replace(
                new RegExp('{{number}}', 'g'),
                project.UF_NUMBER
              )
            "
          >Сгенерировать</a
          >
        </template>

        <div v-if="docInfo.IS_VIEW_ES === 1 && docInfo.IS_VIEW_AND_EDIT_ES.includes(currentUser.ACTIVE_ROLE)"
        style="display: flex; align-items: center; padding-top: 10px;">
          Добавить в Заседания&nbsp;
          <input
            type="checkbox"
            :checked="UF_IS_VIEW_ES[docInfo.TYPE_ID]==1?true:false"
            @change="
                updateIsViewEs($event, loadedFile(docInfo.TYPE_ID, fIndex).ID)
              "
          />
        </div>
      </td>
      <!-- Ссылка название документа -->
      <td
        v-else-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID ===
              loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
                'UF_EXPERTISE_ID'
              ]
        "
      >
        <a
          style="display: inline-block;"
          :href="
            loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)['FILE']
          "
          @click="
            logFileClick(
              loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)['ID']
            )
          "
          class="doc-link"
          target="blank"
        >
          <span v-if="!docInfo.IS_MULTIPLY" v-html="docInfo.NAME"></span>
          <span v-else v-html="docInfo.NAME"></span>
          <span v-if="docInfo.IS_REQ_FILE" class="req_doc">*</span>
        </a>
      </td>
      <!-- Инпут название документа -->
      <td
        v-else-if="
          docInfo.IS_MULTIPLY &&
            currentUser.TYPE_USER === 'declarer' &&
            !doc.IS_FILE_MANAGER_REQUEST
        "
      >
        <input
          type="text"
          class="i-main-style tab-wid-550"
          v-model="docInfo.DOP"
          :placeholder="docInfo.NAME"
          @change="
            changeFileName(
              docInfo.TYPE_ID,
              fIndex,
              docInfo.DOP,
              '',
              docInfo.EXT.split(';')
            )
          "
        />
      </td>
      <!-- Инпут название документа -->
      <td
        v-else-if="
          (docInfo.IS_MULTIPLY || docInfo.UF_IS_MULTY) &&
            isManagerRequest &&
            !isDocumentDeleted(docInfo.TYPE_ID, fIndex)
        "
      >
        <input
          type="text"
          class="i-main-style tab-wid-550"
          v-model="docInfo.DOP"
          @change="
            changeFileName(
              docInfo.TYPE_ID,
              fIndex,
              docInfo.DOP,
              docInfo.DOP_COMMENT,
              docInfo.A_FORMATS
            )
          "
        />
        <br />
        <br />
        <textarea
          style="height: 80px"
          class="i-main-style tab-wid-550"
          v-model="docInfo.DOP_COMMENT"
          placeholder="Комментарий"
          @change="
            changeFileName(
              docInfo.TYPE_ID,
              fIndex,
              docInfo.DOP,
              docInfo.DOP_COMMENT,
              docInfo.A_FORMATS
            )
          "
        ></textarea>
      </td>
      <td
        v-else-if="
          ((docInfo.IS_MULTIPLY || docInfo.UF_IS_MULTY) &&
            isDocumentLoaded(docInfo.TYPE_ID, fIndex)) ||
            isDocumentDeleted(docInfo.TYPE_ID, fIndex)
        "
      >
        {{ docInfo.DOP }}
        <div v-if="loadedFile(docInfo.TYPE_ID, fIndex).UF_COMMENT_MANAGER">
          Комментарий менеджера:
          {{ loadedFile(docInfo.TYPE_ID, fIndex).UF_COMMENT_MANAGER }}
        </div>
      </td>
      <!-- Название документа -->
      <td v-else>
        <span v-if="!docInfo.IS_MULTIPLY && !docInfo.UF_IS_MULTY"
        >
           <span v-html="docInfo.NAME_TYPE_DOCUMENT && docInfo.NAME_TYPE_DOCUMENT !== ''? docInfo.NAME_TYPE_DOCUMENT : docInfo.NAME"></span>
        </span>
        <span
          v-else-if="typeof loadedFile(docInfo.TYPE_ID, fIndex) !== 'undefined'"
        >{{ loadedFile(docInfo.TYPE_ID, fIndex).UF_USER_FILE_NAME }}</span
        >
        <span v-else>{{ docInfo.NAME }}</span>

        <span v-if="docInfo.IS_REQ_FILE" class="req_doc">*</span>

        <template
          v-if="
            docInfo.IS_GENERATE_PREZENT &&
              docInfo.GENERATE_PREZENT_LINK &&
              currentUser.TYPE_USER === 'manager'
          "
        >
          <a
            class="btn btn-info"
            target="_blank"
            :href="
              docInfo.GENERATE_PREZENT_LINK.replace(
                new RegExp('{{number}}', 'g'),
                project.UF_NUMBER
              )
            "
          >Сгенерировать</a
          >
        </template>
      </td>
      <!-- checkbox FORMAT start -->
      <td
        v-if="
          (docInfo.IS_MULTIPLY || docInfo.UF_IS_MULTY) &&
            !isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            isManagerRequest
        "
      >
        <ul style="list-style: none">
          <li v-for="f in formats">
            <input
              v-model="docInfo.A_FORMATS"
              @change="
                //changeFileName отвечает за обновление данных checkbox link-delete-row
                changeFileName(
                  docInfo.TYPE_ID,
                  fIndex,
                  docInfo.DOP,
                  docInfo.DOP_COMMENT,
                  docInfo.A_FORMATS
                )
              "
              :value="f"
              type="checkbox"
            />
            <!-- это тип файла: -->
            {{ f }}
          </li>
        </ul>
      </td>
      <!-- checkbox FORMAT end -->
      <td
        v-else-if="
          (docInfo.IS_MULTIPLY || docInfo.UF_IS_MULTY) &&
            doc.IS_FILE_MANAGER_REQUEST
        "
      >
        {{
          loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
            "UF_FORMAT_REQ_FILE"
            ]
        }}
      </td>
      <td
        v-else-if="
          docInfo.BUTTON_LINK && docInfo.BUTTON_LINK.MODEL_CLASS === 'PlanModel'
        "
      >
        <button
          type="button"
          class="btn btn-info"
          @click="$parent.$parent.loadCalendar(docInfo.TYPE_ID)"
        >
          {{ docInfo.BUTTON_LINK.BUTTON_NAME }}
        </button>
      </td>
      <td
        v-else-if="
          docInfo.BUTTON_LINK &&
            docInfo.BUTTON_LINK.MODEL_CLASS === 'EquipmentZaimModel'
        "
      >
        <button
          type="button"
          class="btn btn-info"
          @click="$parent.$parent.loadPlan()"
        >
          {{ docInfo.BUTTON_LINK.BUTTON_NAME }}
        </button>
      </td>
      <td v-else>
        {{ docInfo.FORMAT_TYPE ? docInfo.FORMAT_TYPE : docInfo.FORMAT }}
      </td>
      <!-- версия  -->
      <td
        v-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            loadedFile(docInfo.TYPE_ID, fIndex).COUNT_VERSION > 0
        "
        style="white-space: nowrap"
      >
        <a @click="getFileHistory(loadedFile(docInfo.TYPE_ID, fIndex).ID)">
          {{ loadedFile(docInfo.TYPE_ID, fIndex)["COUNT_VERSION"] }}
          (История)
        </a>
      </td>
      <td
        v-else-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            loadedFile(docInfo.TYPE_ID, fIndex).COUNT_VERSION > 0
        "
      >
        {{ loadedFile(docInfo.TYPE_ID, fIndex).COUNT_VERSION }}
      </td>
      <td v-else></td>
      <!-- дата загрузки -->
      <td
        v-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID > 0 &&
            docInfo.EXPERTISE_ID ===
              loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
                'UF_EXPERTISE_ID'
              ]
        "
      >
        {{
          loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
            "UF_DATE_UPDATE"
            ]
        }}
      </td>
      <td
        v-else-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) && docInfo.EXPERTISE_ID == 0
        "
      >
        {{ loadedFile(docInfo.TYPE_ID, fIndex)["UF_DATE_UPDATE"] }}
      </td>
      <td v-else></td>
      <!-- соответствие документа -->
      <td
        v-if="
          (isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            !isDocumentDeleted(docInfo.TYPE_ID, fIndex) &&
            acceptAvailable) ||
            (currentUser.ACTIVE_ROLE_CODE === 'manager3' &&
              isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
              !isDocumentDeleted(docInfo.TYPE_ID, fIndex) &&
              acceptStatus(docInfo.TYPE_ID, fIndex) > 0)
        "
      >
        <div style="text-align: center">
          <label class="radio-inline" style="text-align: right;width: 23px">
            <input
              style="margin-left: -25px;"
              type="radio"
              @change="
                updateFileAccept(loadedFile(docInfo.TYPE_ID, fIndex).ID, 1)
              "
              value="1"
              :checked="loadedFile(docInfo.TYPE_ID, fIndex).UF_IS_AKCEPT === 1"
            />
            <span>да</span>
          </label>
          <label class="radio-inline" style="width: 20px">
            <input
              type="radio"
              style="float: left;display: block;"
              @change="
                updateFileAccept(loadedFile(docInfo.TYPE_ID, fIndex).ID, 2)
              "
              value="2"
              :checked="loadedFile(docInfo.TYPE_ID, fIndex).UF_IS_AKCEPT === 2"
            />
            <span>нет</span>
          </label>
        </div>
      </td>
      <td
        v-else-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            loadedFile(docInfo.TYPE_ID, fIndex).UF_IS_AKCEPT > 0
        "
        class="tc-main"
      >
        <div
          class="doc-Y"
          v-if="loadedFile(docInfo.TYPE_ID, fIndex).UF_IS_AKCEPT == 1"
        ></div>
        <div class="doc-N" v-else></div>
      </td>
      <td v-else></td>
      <!-- дата акцепта -->
      <td v-if="isDocumentLoaded(docInfo.TYPE_ID, fIndex)">
        {{ loadedFile(docInfo.TYPE_ID, fIndex)["UF_DATE_AKCEPT"] }}
      </td>
      <td v-else></td>
      <!-- сотрудник фода -->
      <td v-if="isDocumentLoaded(docInfo.TYPE_ID, fIndex)">
        {{ loadedFile(docInfo.TYPE_ID, fIndex)["UF_MANAGER_AKCEPT_NAME"] }}
      </td>
      <td v-else></td>
      <!-- эцп -->
      <td
        style="white-space: nowrap;"
        v-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID === 0 &&
            loadedFile(docInfo.TYPE_ID, fIndex).UF_FILE_SIGN_AUTHOR
        "
      >
        <div
          class="doc-Y"
          v-if="loadedFile(docInfo.TYPE_ID, fIndex).UF_IS_SIGN_ECP"
        ></div>
        <div class="doc-N" v-else></div>
      </td>
      <td
        style="white-space: nowrap;"
        v-else-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID > 0 &&
            docInfo.EXPERTISE_ID ===
              loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
                'UF_EXPERTISE_ID'
              ] &&
            loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
              'UF_FILE_SIGN_AUTHOR'
            ]
        "
      >
        <div
          class="doc-Y"
          v-if="
            loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
              'UF_IS_SIGN_ECP'
            ]
          "
        ></div>
        <div class="doc-N" v-else></div>
      </td>
      <td v-else></td>
      <!-- modal ECP -->
      <td
        style="white-space: nowrap;"
        v-if="
          (isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID == 0 &&
            loadedFile(docInfo.TYPE_ID, fIndex).UF_FILE_SIGN_AUTHOR) ||
            (isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
              docInfo.EXPERTISE_ID > 0 &&
              docInfo.EXPERTISE_ID ===
                loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
                  'UF_EXPERTISE_ID'
                ] &&
              loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
                'UF_FILE_SIGN_AUTHOR'
              ])
        "
      >
        <div class="esd-data">
          <!-- <a
            v-for="item in docInfo.ECP_GET_MANAGER_LIST"
            v-if="item.ACTIVE_CODE === currentUser.ACTIVE_ROLE_CODE"
            @click="getLinkFileECP(loadedFile(docInfo.TYPE_ID, fIndex).ID)"
            ><img src="/images/methods/doc_ok.png"
          /></a>-->
          <i
            v-if="
              isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
                docInfo.EXPERTISE_ID > 0 &&
                docInfo.EXPERTISE_ID ===
                  loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
                    'UF_EXPERTISE_ID'
                  ]
            "
            class="esd-data esd_icon"
            @click="
              getECPInfo(
                loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)['ID']
              )
            "
            style="margin-right: 25px"
          >
            ЭЦП
            <img src="/images/i-eds.png" />
          </i>

          <i
            v-else
            class="esd-data esd_icon"
            @click="getECPInfo(loadedFile(docInfo.TYPE_ID, fIndex).ID)"
            style="margin-right: 25px"
          >
            ЭЦП
            <img src="/images/i-eds.png" />
          </i>

          <div class="esd-data__info" v-show="resultECP">
            <div class="esd-close" @click="closeECP">
              <i class="esd_exit"></i>
            </div>
            <div v-if="resultECP">
              <p class="text-center">
                Подлинник электронного документа, подписанного ЭЦП,
                <br />хранится в информационной системе “Личный кабинет
                заемщика” <br />Фонда развития промышленности
              </p>
              <h3 class="esd-title">Сведения о сертификате ЭП</h3>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Сертификат:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn">
                    {{ result.SERTIFICATE_NUMBER }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Кем выдан:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.ISSUER }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Организация:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.COMPANY }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">Кому выдан:</div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.OWNER_FIO }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                    Действителен:
                  </div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.DATE_USE_SERTIFICATE }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                    Название документа:
                  </div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.FILE_NAME }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-4 col-md-4 stl-col-pb-8">
                    Дата загрузки:
                  </div>
                  <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                    {{ result.FILE_DATE_LOAD }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </td>
      <td v-else></td>
      <!-- modal ECP -->
      <!-- подписант -->
      <td
        style="white-space: nowrap;"
        v-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID > 0 &&
            docInfo.EXPERTISE_ID ===
              loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
                'UF_EXPERTISE_ID'
              ] &&
            loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
              'UF_FILE_SIGN_AUTHOR'
            ]
        "
      >
        <div>
          <a
            v-for="item in docInfo.ECP_GET_MANAGER_LIST"
            v-if="item.ACTIVE_CODE === currentUser.ACTIVE_ROLE_CODE"
            @click="
              getLinkFileECP(
                loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)['ID'],
                'txt'
              )
            "
          >
            <img src="/images/ecp/txt.png" />
          </a>

          <a
            v-for="item in docInfo.ECP_GET_MANAGER_LIST"
            v-if="item.ACTIVE_CODE === currentUser.ACTIVE_ROLE_CODE"
            @click="
              getLinkFileECP(loadedFile(docInfo.TYPE_ID, fIndex).ID, 'sig')
            "
          >
            <img src="/images/ecp/sig.png" />
          </a>

          {{
            loadedFileUfExpId(docInfo.TYPE_ID, docInfo.EXPERTISE_ID)[
              "UF_FILE_SIGN_AUTHOR"
              ]
          }}
        </div>
      </td>

      <td
        style="white-space: nowrap;"
        v-else-if="
          isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
            docInfo.EXPERTISE_ID === 0 &&
            loadedFile(docInfo.TYPE_ID, fIndex).UF_FILE_SIGN_AUTHOR
        "
      >
        <div>
          <a
            v-for="item in docInfo.ECP_GET_MANAGER_LIST"
            v-if="item.ACTIVE_CODE === currentUser.ACTIVE_ROLE_CODE"
            @click="
              getLinkFileECP(loadedFile(docInfo.TYPE_ID, fIndex).ID, 'txt')
            "
          >
            <img src="/images/ecp/txt.png" />
          </a>

          <a
            v-for="item in docInfo.ECP_GET_MANAGER_LIST"
            v-if="item.ACTIVE_CODE === currentUser.ACTIVE_ROLE_CODE"
            @click="
              getLinkFileECP(loadedFile(docInfo.TYPE_ID, fIndex).ID, 'sig')
            "
          >
            <img src="/images/ecp/sig.png" />
          </a>

          {{ loadedFile(docInfo.TYPE_ID, fIndex).UF_FILE_SIGN_AUTHOR }}
        </div>
      </td>
      <td v-else></td>
      <td></td>
      <td>
        <a
          v-show="
            (isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
              loadedFile(docInfo.TYPE_ID, fIndex).UF_IS_AKCEPT != 1 &&
              !isDocumentDeleted(docInfo.TYPE_ID, fIndex) &&
              ((currentUser.TYPE_USER === 'declarer' &&
                docInfo.IS_LOAD_FILE_USER) ||
                (currentUser.TYPE_USER === 'manager' &&
                  docInfo.IS_LOAD_FILE_MANAGER &&
                  checkUploadManager(docInfo)))) ||
              doc.IS_FILE_MANAGER_REQUEST === 1
            // &&
            // loadedFile(docInfo.TYPE_ID, fIndex).UF_AUTHOR_REQUEST_NAME ===
            //   currentUser.NAME
          "
          @click="deleteFile(docInfo.TYPE_ID, fIndex)"
          class="link-delete-row"
          style="margin: 0 10px;"
        ></a>

        <!-- письма поддержки, иные документы, возможность удалить -->
        <a
          v-show="
            docInfo.TYPE_ID > 0 &&
              !isDocumentLoaded(docInfo.TYPE_ID, fIndex) &&
              docInfo.TYPE_ID == 453705 &&
              isFindRecordDocument(docInfo.TYPE_ID, fIndex) &&
              !isDocumentDeleted(docInfo.TYPE_ID, fIndex) &&
              currentUser.TYPE_USER === 'declarer' &&
              doc.IS_LOAD_FILE_USER == 1 &&
              (doc.IS_MULTIPLY == 1 || docInfo.UF_IS_MULTY)
          "
          @click="deleteFile(docInfo.TYPE_ID, fIndex)"
          class="link-delete-row"
          style="margin: 0 10px;"
        ></a>
      </td>
    </tr>
    <!-- кнопка добавить документ или запросить документ -->
    <!-- <tr
      v-if="
        doc.IS_MULTIPLY === 1 &&
          doc.IS_LOAD_FILE_USER === 1 &&
          //  currentUser.TYPE_USER === 'declarer' &&
          //  !doc.IS_FILE_MANAGER_REQUEST ||
          // add if  isManagerRequest && doc.IS_FILE_MANAGER_REQUEST
          isManagerRequest
        //&&
        // !doc.IS_FILE_MANAGER_REQUEST
        //(currentUser.ACTIVE_ROLE_CODE === 'lizing' ||
        // currentUser.ACTIVE_ROLE_CODE === 'users')
      "
    >
      <td colspan="9">
        <b
          ><a @click="addFile(doc.TYPE_ID)" class="add-t-r"></a>Запросить
          документ</b
        >
      </td>
    </tr>
    <tr
      v-else-if="
        // doc.IS_MULTIPLY &&
        // add if declarer
        //(currentUser.TYPE_USER === 'declarer' ||
        // currentUser.TYPE_USER === 'manager') &&
        //doc.IS_FILE_MANAGER_REQUEST
       (currentUser.ACTIVE_ROLE_CODE === 'lizing' ||
        currentUser.ACTIVE_ROLE_CODE === 'users') &&
        doc.IS_FILE_MANAGER_REQUEST === 1 && isManagerRequest
      "
    >
      <td colspan="9">
        <b
          ><a @click="addFile(doc.TYPE_ID)" class="add-t-r"></a>Добавить
          документ</b
        >
      </td>
    </tr>-->
    <tr
      v-if="
        doc.IS_MULTIPLY &&
          //  currentUser.TYPE_USER === 'declarer' &&
          //  !doc.IS_FILE_MANAGER_REQUEST ||
          // add if  isManagerRequest && doc.IS_FILE_MANAGER_REQUEST
          isManagerRequest &&
          doc.IS_FILE_MANAGER_REQUEST
      "
    >
      <td colspan="9">
        <b>
          <a @click="addFile(doc.TYPE_ID)" class="add-t-r"></a> Запросить
          документ
        </b>
      </td>
    </tr>
    <tr
      v-if="
        doc.IS_MULTIPLY &&
          // add if declarer
          //  currentUser.TYPE_USER === 'declarer' &&
          (currentUser.ACTIVE_ROLE_CODE === 'lizing' ||
            currentUser.ACTIVE_ROLE_CODE === 'users') &&
          //currentUser.TYPE_USER === 'manager' &&
          //doc.IS_FILE_MANAGER_REQUEST
          !doc.IS_FILE_MANAGER_REQUEST &&
          doc.IS_LOAD_FILE_USER === 1
      "
    >
      <td colspan="9">
        <!-- цепочка запросов addFile тип файлов -->
        <b>
          <a @click="addFile(doc.TYPE_ID)" class="add-t-r"></a> Добавить
          документ
        </b>
      </td>
    </tr>
  </fragment>
</template>

<script>
import Vue from "vue";
import { ExpertAdvice, ProjectsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import { AUTH_URL } from "@/common/config";
import { Dropdown as VDropdown } from "floating-vue";

Vue.filter("cleanFormats", function(value) {
  let formats = [];

  value.split(";").forEach(function(v) {
    if (v !== "") {
      formats.push(v);
    }
  });

  return formats.join(", ");
});

export default {
  name: "TableRow",
  components: { VDropdown },
  props: [
    "doc",
    "index",
    "documentConf",
    "docIndex",
    "documentHistory",
    "record"
  ],
  data() {
    return {
      repeats: 1,
      result: "",
      resultECP: false,
      tosterErrors: [],
      activeTooltip: null,
      UF_IS_VIEW_ES: []
    };
  },
  mounted() {
    if (this.documentConf.FILE_DOCUMENTS_PATH[this.doc.TYPE_ID]) {
      this.repeats = this.documentConf.FILE_DOCUMENTS_PATH[
        this.doc.TYPE_ID
        ].length;
    }
  },
  methods: {
    openTooltip(key) {
      this.activeTooltip = key;
    },
    closeTooltip() {
      this.activeTooltip = null;
    },
    closeECP() {
      this.resultECP = !this.resultECP;
    },
    getECPInfo(idFile) {
      ProjectsService.getECPInfoFile(this.project.ID, idFile).then(
        ({ data }) => {
          this.result = data.result;
          this.resultECP = true;
          console.log(this.resultECP);
        }
      );
    },
    getLinkFileECP(id, format) {
      ProjectsService.getLinkFileECP(this.project.ID, id, format).then(
        ({ data }) => {
          window.location.href =
            AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        }
      );
    },
    addFile(typeId) {
      if (
        this.doc.IS_MULTIPLY === 1 &&
        this.doc.IS_LOAD_FILE_USER === 1 &&
        (this.currentUser.ACTIVE_ROLE_CODE === "lizing" ||
          this.currentUser.ACTIVE_ROLE_CODE === "users")
      ) {
        ProjectsService.addRequestDocument(this.project.ID, {
          UF_USER_FILE_NAME: "Дополнительный документ",
          TYPE_ID: typeId,
          UF_COMMENT_MANAGER: "",
          UF_FORMAT_REQ_FILE: ""
        }).then(response => {
          if (!response.data.error) {
            this.repeats++;
            this.updateDocInfo();
          }
        }, this);
      } else {
        ProjectsService.addRequestDocument(this.project.ID, {
          UF_USER_FILE_NAME: "",
          TYPE_ID: typeId,
          UF_COMMENT_MANAGER: "",
          UF_FORMAT_REQ_FILE: ""
        }).then(response => {
          if (!response.data.error) {
            this.repeats++;
            this.updateDocInfo();
          }
        }, this);
      }
      // ProjectsService.addRequestDocument(this.project.ID, {
      //   UF_USER_FILE_NAME: "",
      //   TYPE_ID: typeId,
      //   UF_COMMENT_MANAGER: "",
      //   UF_FORMAT_REQ_FILE: ""
      // }).then(response => {
      //   if (!response.data.error) {
      //     this.repeats++;
      //     this.updateDocInfo();
      //   }
      // }, this);
    },
    checkUploadManager(doc) {
      let skip = true;
      doc.LOAD_MANAGER_LIST.forEach(function(v) {
        if (this.currentUser.ACTIVE_ROLE_CODE === v.ACTIVE_CODE) {
          skip = false;
        }
      }, this);
      return !skip;
    },
    isDocumentLoaded(typeId, index) {
      const fd = this.fileData[index];
      return fd ? fd.isLoaded : false;
    },
    isFindRecordDocument(typeId, index) {
      const fd = this.fileData[index];
      return fd ? fd.hasRecord : false;
    },
    loadedFile(typeId, fIndex) {
      const fd = this.fileData[fIndex];
      if (!fd) return undefined;
      if (!this.record && fd.file) {
        this.UF_IS_VIEW_ES[typeId] = fd.file.UF_IS_VIEW_ES;
      }
      return fd.file;
    },
    loadedFileUfExpId(typeId, docInfoId) {
      //console.log('typeId: ', typeId, 'docInfoId: ', docInfoId)
      if (this.documentConf.FILE_DOCUMENTS_PATH[typeId]) {
        let fileLoad = [];
        fileLoad = this.documentConf.FILE_DOCUMENTS_PATH[typeId].filter(
          c => c.UF_EXPERTISE_ID === docInfoId
        );
        // console.log("fileLoad[fIndex] ", JSON.parse(JSON.stringify(fileLoad[0])));
        if (fileLoad.length) {
          return fileLoad[0];
        }
        return false;
      }
    },
    acceptStatus(typeId, fIndex) {
      const fd = this.fileData[fIndex];
      return fd ? fd.acceptStatus : 0;
    },
    isDocumentDeleted(typeId, index) {
      const fd = this.fileData[index];
      return fd ? fd.isDeleted : false;
    },
    getFileHistory(id) {
      ProjectsService.getHistoryVersionDocument(this.$route.params.id, id).then(
        ({ data }) => {
          console.log(data.FILE_VERSION_HISTORY);
          this.$parent.$parent.documentHistory = data.FILE_VERSION_HISTORY;
        },
        this
      );
    },
    updateDocInfo() {
      ProjectsService.getDocumentESProjects(this.$route.params.id).then(
        ({ data }) => {
          this.documentConf.FILE_LOAD_INFO = data.FILE_LOAD_INFO;
          this.documentConf.FILE_ACCEPT_INFO = data.FILE_ACCEPT_INFO;
          this.documentConf.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH;
          this.documentConf.LIST_TYPE = data.LIST_TYPE;
        },
        this
      );
    },
    updateFileAccept(id, accept) {
      // Оптимистичное обновление: меняем UF_IS_AKCEPT локально сразу
      const filePaths = this.documentConf.FILE_DOCUMENTS_PATH[this.doc.TYPE_ID];
      const entry = filePaths && filePaths.find(f => f.ID === id);
      const prevAccept = entry ? entry.UF_IS_AKCEPT : undefined;
      if (entry) {
        this.$set(entry, "UF_IS_AKCEPT", accept);
      }

      ProjectsService.saveAcceptDocument(this.project.ID, {
        ID: id,
        UF_IS_AKCEPT: accept
      }).then(({ data }) => {
        if (data.error) {
          // Откатываем оптимистичное обновление при ошибке
          if (entry) this.$set(entry, "UF_IS_AKCEPT", prevAccept);
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          }, this);
        } else {
          // Обновляем только счётчики — LIST_TYPE и FILE_DOCUMENTS_PATH не трогаем
          ProjectsService.getDocumentESProjects(this.$route.params.id).then(({ data: docData }) => {
            this.documentConf.FILE_LOAD_INFO = docData.FILE_LOAD_INFO;
            this.documentConf.FILE_ACCEPT_INFO = docData.FILE_ACCEPT_INFO;
          }, this);
        }
      }, this);
    },
    deleteFile(typeId, index) {
      let id = 0;
      if (this.record > 0) {
        this.documentConf.FILE_DOCUMENTS_PATH[typeId].forEach(function(rec) {
          if (this.record === rec.RECORD_MODEL_ID) {
            id = rec.ID;
          }
        }, this);
      } else {
        id = this.documentConf.FILE_DOCUMENTS_PATH[typeId][index].ID;
      }

      ProjectsService.deleteDocument(this.project.ID, id).then(response => {
        if (response.data.result) {
          this.tosterErrors.forEach(function(err) {
            err.goAway(0);
          });

          this.updateDocInfo();

          this.$toasted.show("Документ удален", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        } else if (response.data.error) {
          response.data.error.forEach(function(err) {
            this.tosterErrors[this.tosterErrors.length] = this.$toasted.show(
              err.TEXT,
              {
                theme: "bubble",
                position: "bottom-right",
                duration: 3000,
                action: [
                  {
                    text: "Закрыть",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  {
                    text: "Закрыть все",
                    onClick: () => {
                      this.tosterErrors.forEach(function(err) {
                        err.goAway(0);
                      });
                    }
                  }
                ]
              }
            );
          }, this);
        }
      }, this);
    },
    logFileClick(id) {
      ProjectsService.saveLogViewDocument(id).then(({ data }) => {
        console.log(data);
      }, this);
    },
    changeFileName(typeId, index, name, comment, formats) {
      if (!this.documentConf.FILE_DOCUMENTS_PATH[typeId]) {
        this.documentConf.FILE_DOCUMENTS_PATH[typeId] = [];
      }
      if (!this.documentConf.FILE_DOCUMENTS_PATH[typeId][index]) {
        this.documentConf.FILE_DOCUMENTS_PATH[typeId][index] = {
          COUNT_VERSION: 0,
          FIELD_MODEL_ID: "",
          FILE: null,
          ID: 0,
          RECORD_MODEL_ID: "",
          TYPE_ID: typeId,
          UF_AUTHOR_REQUEST_ID: null,
          UF_AUTHOR_REQUEST_NAME: "",
          UF_COMMENT_MANAGER: comment,
          UF_DATE_AKCEPT: null,
          UF_DATE_DELETE: null,
          UF_DATE_LOAD: null,
          UF_DATE_UPDATE: null,
          UF_FILE_SIGN_AUTHOR: null,
          UF_FILE_SIGN_ECP: null,
          UF_FORMAT_REQ_FILE: formats.join(";"),
          UF_IS_AKCEPT: null,
          UF_IS_DELETE: 0,
          UF_IS_REQUEST_DOC: null,
          UF_IS_SIGN_ECP: null,
          UF_KONSORCIUM: null,
          UF_KONSORCIUM_CODE: null,
          UF_MANAGER_AKCEPT: null,
          UF_MANAGER_AKCEPT_NAME: "",
          UF_USER_FILE_NAME: name
        };
      }

      if (this.currentUser.ACTIVE_ROLE_CODE === "users") {
        if (this.documentConf.FILE_DOCUMENTS_PATH[typeId][index].ID === 0) {
          ProjectsService.addNewDocument(this.project.ID, {
            UF_USER_FILE_NAME: name,
            TYPE_ID: typeId
          }).then(() => {
            this.updateDocInfo();
          }, this);
        } else {
          ProjectsService.editDocument(
            this.project.ID,
            this.documentConf.FILE_DOCUMENTS_PATH[typeId][index].ID,
            {
              UF_USER_FILE_NAME: name,
              TYPE_ID: typeId
            }
          ).then(() => {
            this.updateDocInfo();
          }, this);
        }
      } else {
        let exts = [];
        formats.forEach(function(v) {
          if (v !== "") {
            exts.push(v);
          }
        });

        if (this.documentConf.FILE_DOCUMENTS_PATH[typeId][index].ID === 0) {
          ProjectsService.addRequestDocument(this.project.ID, {
            UF_USER_FILE_NAME: name,
            TYPE_ID: typeId,
            UF_COMMENT_MANAGER: comment,
            UF_FORMAT_REQ_FILE: exts.join(";") + ";"
          }).then(response => {
            if (!response.data.error) {
              this.updateDocInfo();
            }
          }, this);
        } else {
          ProjectsService.editRequestDocument(
            this.project.ID,
            this.documentConf.FILE_DOCUMENTS_PATH[typeId][index].ID,
            {
              UF_USER_FILE_NAME: name,
              TYPE_ID: typeId,
              UF_COMMENT_MANAGER: comment,
              UF_FORMAT_REQ_FILE: exts.join(";") + ";"
            }
          ).then(response => {
            if (!response.data.error) {
              this.updateDocInfo();
            }
          }, this);
        }
      }
    },
    updateIsViewEs(event, fileId){
      ProjectsService.updateIsViewEs(this.project.ID, fileId, {
        UF_IS_VIEW_ES: Number(event.target.checked)
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.updateDocInfo();

          let textOp = (Number(event.target.checked) === 1)?'Документ добавлен в Заседания':'Документ удален из Заседания';

          this.$toasted.show(textOp, {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
        }
      }, this).catch( error => {
        if (error.message.includes("HttpCode:403")) {
          //this.$router.push({ name: "ForbiddenPage403" });
          this.$toasted.show('Операция закрыта для пользователя настройками безопасности', {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        }
        if (error.message.includes("HttpCode:404")) {
          //this.$router.push({ name: "NotFoundPage404" });
          this.$toasted.show('Проект закрыт для пользователя', {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        }
      });


    },
    setIsNew(event, id) {
      ExpertAdvice.setIsNewDocuments(id, {
        UF_IS_NEW: Number(event.target.checked)
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.fetchItemsSetNew();
        }
      }, this);
    },
  },
  asyncComputed: {
    async formats() {
      let f = [];
      if (
        this.doc.IS_MULTIPLY &&
        this.currentUser.TYPE_USER === "manager" &&
        this.doc.IS_FILE_MANAGER_REQUEST
      ) {
        await ProjectsService.getTypeFileExtensionForUserRequest().then(
          response => {
            let b = response.data.items;
            f = b
              .join(", ")
              .toUpperCase()
              .split(", ");
          },
          this
        );
      }
      return f;
    }
  },
  computed: {
    // Pre-computes all file lookups for this doc once, instead of calling
    // loadedFile/isDocumentLoaded/acceptStatus/isDocumentDeleted 40+ times per row in the template.
    isManagerRequest() {
      if (this.currentUser.TYPE_USER !== "manager") return false;
      if (!this.doc.IS_FILE_MANAGER_REQUEST) return false;
      return this.doc.GROUP_REQUEST_MANAGER_LIST.some(
        role => role.ACTIVE_CODE === this.currentUser.ACTIVE_ROLE_CODE
      );
    },
    acceptAvailable() {
      return this.doc.ACCEPT_MANAGER_LIST.some(
        r => r.ACTIVE_CODE === this.currentUser.ACTIVE_ROLE_CODE
      );
    },
    fileData() {
      const typeId = this.doc.TYPE_ID;
      const filePaths = this.documentConf.FILE_DOCUMENTS_PATH[typeId];
      if (!filePaths) return [];

      let entries;
      if (this.record > 0) {
        entries = filePaths.filter(rec => rec.RECORD_MODEL_ID === this.record);
      } else {
        entries = filePaths;
      }

      return entries.map(entry => ({
        file: entry,
        isLoaded: !!entry.FILE,
        isDeleted: !!entry.UF_IS_DELETE,
        acceptStatus: entry.FILE ? (entry.UF_IS_AKCEPT || 0) : 0,
        hasRecord: !!entry.ID
      }));
    },
    docs() {
      let docs = [];
      if (!this.doc.IS_MULTIPLY) {
        docs.push(this.doc);
      } else {
        for (let i = 0; i < this.repeats; i++) {
          const fileEntry = this.documentConf.FILE_DOCUMENTS_PATH[this.doc.TYPE_ID] &&
            this.documentConf.FILE_DOCUMENTS_PATH[this.doc.TYPE_ID][i];
          docs.push(Object.assign({}, this.doc, {
            DOP: fileEntry ? fileEntry.UF_USER_FILE_NAME : "",
            DOP_ID: fileEntry ? fileEntry.ID : "",
            DOP_COMMENT: fileEntry ? fileEntry.UF_COMMENT_MANAGER : "",
            A_FORMATS: fileEntry && fileEntry.UF_FORMAT_REQ_FILE
              ? fileEntry.UF_FORMAT_REQ_FILE.split(";")
              : []
          }));
        }
      }
      //console.log("Docs: ", JSON.parse(JSON.stringify(docs)));
      return docs;
    },
    ...mapGetters(["project", "currentUser"])
  }
};
</script>

<style scoped></style>
